/** Modulo Spese: note spese con giustificativi, approvazione e rimborso. */
import { z } from "zod";
import { isoDay, optionalText, uuid } from "./common.js";

export const EXPENSE_STATUSES = ["draft", "submitted", "approved", "rejected", "reimbursed"] as const;
export type ExpenseStatus = (typeof EXPENSE_STATUSES)[number];
export const EXPENSE_STATUS_LABEL: Record<ExpenseStatus, string> = { draft: "Bozza", submitted: "Da approvare", approved: "Approvata", rejected: "Respinta", reimbursed: "Rimborsata" };
export const EXPENSE_CATEGORIES = ["Treno e aereo", "Rimborso chilometrico", "Carburante", "Pedaggi e parcheggi", "Taxi e mezzi locali", "Noleggio auto", "Vitto", "Alloggio", "Materiali", "Altro"] as const;
export const MILEAGE_CATEGORY = "Rimborso chilometrico";
export const PAYMENT_METHODS = ["personal", "company"] as const;
export const PAYMENT_METHOD_LABEL: Record<(typeof PAYMENT_METHODS)[number], string> = { personal: "Anticipata da me", company: "Carta o pagamento aziendale" };

export const expenseInputSchema = z
  .object({
    date: isoDay,
    category: z.string().trim().min(1).max(60),
    description: z.string().trim().min(1).max(300),
    amountCents: z.number().int().min(0).max(100_000_000),
    km: z.number().min(0).max(20_000).nullable().default(null),
    paymentMethod: z.enum(PAYMENT_METHODS).default("personal"),
    contractId: uuid.nullable().default(null),
    projectId: uuid.nullable().default(null),
    rebillable: z.boolean().default(true),
  })
  .refine((v) => v.category !== MILEAGE_CATEGORY || (v.km ?? 0) > 0, { message: "Indica i chilometri", path: ["km"] })
  .refine((v) => v.category === MILEAGE_CATEGORY || v.amountCents > 0, { message: "Indica l'importo", path: ["amountCents"] });
export type ExpenseInput = z.infer<typeof expenseInputSchema>;

export const expenseListSchema = z.object({
  scope: z.enum(["mine", "all"]).default("mine"),
  status: z.enum(EXPENSE_STATUSES).optional(),
  userId: uuid.optional(),
  contractId: uuid.optional(),
  from: isoDay.optional(),
  to: isoDay.optional(),
});
export const expenseReviewSchema = z.object({ ids: z.array(uuid).min(1).max(500), approve: z.boolean(), reason: optionalText(500) });
export const expenseReimburseSchema = z.object({ ids: z.array(uuid).min(1).max(500), date: isoDay, accountId: uuid.nullish() });
export const expenseReportSchema = z.object({ from: isoDay, to: isoDay, userId: uuid.optional() });

/** Importo del rimborso chilometrico. */
export const mileageCents = (km: number, rateCents: number) => Math.round(km * rateCents);
